import React from "react";

import { observer } from "mobx-react";

import { useStores } from "../../../../contexts/StoreContext";
import CustomSelect from "../../../CustomSelect/CustomSelect";
import Loader from "../../Loader/Loader";

const filterMap = {
  FULL_TIME: "Full Time",
  PART_TIME: "Part Time",
  BOTH: "Both",
};

function HoursFilter({ isLoading, label, className, borderRadius = "10px" }) {
  const { filtersStore } = useStores();

  const { applyFilters, setFromFilter, frontendFilters } = filtersStore;

  const handleChange = (vacancyCategories) => {
    setFromFilter("hours", [vacancyCategories.value]);
    applyFilters();
  };

  if (isLoading) {
    return <Loader />;
  }

  const roleSelectStyles = {
    container: (provided) => {
      return {
        ...provided,
        height: "100%",
        width: "100%",
      };
    },
    control: (provided) => ({
      ...provided,
      background: "white",
      borderRadius,
      boxShadow: "none",
      fontWeight: "400",
      height: "100%",
      textColor: "black",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0",
      color: "black",
    }),
    option: (provided) => ({
      ...provided,
      color: "black",
      height: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };

  if (isLoading) {
    return <Loader />;
  }

  let value = null;

  if (frontendFilters.hours?.length > 0) {
    value = {
      label: filterMap[frontendFilters.hours[0]],
      value: frontendFilters.hours[0],
    };
  }
  return (
    <CustomSelect
      styles={roleSelectStyles}
      id="hours"
      className={className}
      onChange={handleChange}
      placeholder={label}
      aria-label={label}
      aria-labelledby={label ? `${label}-label` : undefined}
      options={[
        { label: "Full Time", value: "FULL_TIME" },
        { label: "Part Time", value: "PART_TIME" },
        { label: "Both", value: "BOTH" },
      ]}
      value={value}
    />
  );
}

export default observer(HoursFilter);
